import React, { useState, useEffect } from 'react';
import HelpTogal from '../TogelButton/HelpTogal';
import SallerServices from '../../services/SallerServices';
import CarServices from '../../services/CarServices';
function SallerUpdate({ user, closeModal, onSuccess }) {
  const [formValues, setFormValues] = useState({
    deviceType: '',
    firstName: '',
    lastName: '',
    email: '',
    mobileNo: '',
    state: '',
    stateName: '',
    city: '',
    cityName: '',
    address: '',
    pincode: '',
    dob: '',
    doa: '',
    age: '',
    earningType: '',
    bulding: '',
    apartment: '',
    floor: '',
    street: '',
    image: ''
  });
  const [addressType, setAddressType] = useState('');
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [loadingCities, setLoadingCities] = useState(false);
  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png');
  useEffect(() => {
    if (user) {
      setFormValues({
        deviceType: user?.deviceType || '',
        firstName: user?.firstName || '',
        lastName: user?.lastName || '',
        email: user?.email || '',
        mobileNo: user?.mobileNo || '',
        address: user?.address || '',
        state: user?.state?._id || user?.state || '',
        stateName: user?.state?.name || '',
        city: user?.city?._id || user?.city || '',
        cityName: user?.city?.name || '',
        pincode: user?.pincode || '',
        dob: user?.dob || '',
        doa: user?.doa || '',
        age: user?.age || '',
        earningType: user?.earningType || '',
        floor: user?.floor || '',
        bulding: user?.bulding || '',
        apartment: user?.apartment || '',
        street: user?.street || '',
        image: ''
      });
      setAddressType(user?.addressType || '');
      if (user.image) {
        setPreviewImage(process.env.REACT_APP_URL + user.image);
      }
    }
  }, [user]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    // 👇 State change pe city reset karo
    if (name === "state") {
      setFormValues(prev => ({
        ...prev,
        state: value,
        city: "",
        cityName: ""
      }));
      return;
    }

    setFormValues(prev => ({
      ...prev,
      [name]: value
    }));
  };
  useEffect(() => {
    CarServices.getState().then(res => {
      if (res.status) setStates(res.data);
    });
  }, []);
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        image: file,
      });
    }
  };
  useEffect(() => {
    const fetchCities = async () => {
      if (formValues.state) {
        setLoadingCities(true);
        try {
          const res = await CarServices.getCities(formValues.state);
          if (res.status) {
            setCities(res.data);
          } else {
            setCities([]);
          }
        } catch (error) {
          console.error("City fetch error", error);
          setCities([]);
        } finally {
          setLoadingCities(false);
        }
      } else {
        setCities([]);
      }
    };

    fetchCities();
  }, [formValues.state]);
  const handleAddressTypeChange = (event) => {
    setAddressType(event.target.value); // Update address type when user selects a radio button
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    const selectedCity = cities.find(c => c._id === formValues.city);
    const selectedState = states.find(s => s._id === formValues.state);
    try {
      const formData = new FormData();
      formData.append("earningType", formValues.earningType);
      formData.append("doa", formValues.doa);
      formData.append("dob", formValues.dob);
      formData.append("age", formValues.age);
      formData.append("pincode", formValues.pincode);

      // formData.append("cityName", formValues.cityName);
      formData.append("cityName", selectedCity?.name || "");
      // formData.append("city", formValues.city);
      formData.append("city", formValues.city);
      // formData.append("stateName", formValues.stateName);
      formData.append("stateName", selectedState?.name || "");
      formData.append("state", formValues.state);

      formData.append("address", formValues.address);

      formData.append("mobileNo", formValues.mobileNo);
      formData.append("email", formValues.email);

      formData.append("lastName", formValues.lastName);
      formData.append("firstName", formValues.firstName);
      formData.append("addressType", addressType);
      if (formValues.image) {
        formData.append("image", formValues.image);
      }
      // for (const key in formValues) {
      //   if (key !== 'image' || formValues[key] instanceof File) {
      //     formData.append(key, formValues[key]);
      //   }
      // }

      await SallerServices.updateSeller(user.id, formData);
      alert('Seller updated successfully');
      onSuccess();
      closeModal();
    } catch (error) {
      console.error('Failed to update  user', error);
      alert('Failed to update  user');
    }
  };

  return (
    <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Saller Edit</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
          </div>
          <div className="modal-body">
            <div className="container-box px-5">
              <div className="container-box-inner table-reponsive-tabe">
                <div className="page-details">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>First Name</label>
                          <input type="text" name="firstName" className="form-control" value={formValues.firstName} onChange={handleInputChange} placeholder="New first name" />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>Last Name</label>
                          <input type="text" name="lastName" className="form-control" value={formValues.lastName} onChange={handleInputChange} placeholder="New Last Name" />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>Mobile No</label>
                          <input
                            type="tel"
                            name="mobileNo"
                            className="form-control"
                            value={formValues.mobileNo}
                            onChange={handleInputChange}
                            pattern="[0-9]{10}"
                            maxLength="10"
                            placeholder="New mobile"
                            readOnly
                          />
                        </div>
                      </div>

                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>Email</label>
                          <input type="text" name="email" className="form-control" value={formValues.email} onChange={handleInputChange} placeholder="New email" readOnly />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>State</label>
                          {/* State */}
                          <select
                            name="state"
                            className="form-control"
                            value={formValues.state}
                            onChange={handleInputChange}
                          >
                            <option value="">Select State</option>
                            {states.map(state => (
                              <option key={state._id} value={state._id}>
                                {state.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>City</label>
                          {/* City */}
                          <select
                            name="city"
                            className="form-control"
                            value={formValues.city}
                            onChange={handleInputChange}
                            disabled={!formValues.state || loadingCities}
                          >
                            <option value="">
                              {loadingCities ? "Loading..." : "Select City"}
                            </option>
                            {cities.map(city => (
                              <option key={city._id} value={city._id}>
                                {city.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>Address</label>
                          <input type="text" name="address" className="form-control" value={formValues.address} onChange={handleInputChange} placeholder="New address" />
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6">
                        <div className="input-field">
                          <label>Earning Type</label>
                          <select
                            name="earningType"
                            className="form-control"
                            value={formValues.earningType || ""}
                            onChange={handleInputChange}
                          >
                            <option value="">Select</option>
                            <option value="Salary">Salary</option>
                            <option value="Commission">Commission</option>
                            <option value="Both">Both</option>
                          </select>
                        </div>
                      </div>
                      {/* Address Type Radio Button Section
                      <div className="col-sm-3">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="addressType"
                            value="Home"
                            id="flexRadioDefault1"
                            checked={addressType === 'Home'}
                            onChange={handleAddressTypeChange}
                          />
                          <label className="form-check-label" htmlFor="flexRadioDefault1">
                            Set as current home address
                          </label>
                        </div>
                      </div> */}


                      {/* ===== Extra Details Section ===== */}
                      <div className="row mt-3">

                        {/* DOB */}
                        <div className="col-lg-6 col-sm-6">
                          <div className="input-field">
                            <label>Date of Birth</label>
                            <input
                              type="date"
                              name="dob"
                              className="form-control"
                              value={formValues.dob}
                              onChange={handleInputChange}

                            />
                          </div>
                        </div>

                        {/* DOA */}
                        <div className="col-lg-6 col-sm-6">
                          <div className="input-field">
                            <label>Date of Anniversary</label>
                            <input
                              type="date"
                              name="doa"
                              className="form-control"
                              value={formValues.doa}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>

                        {/* Age */}
                        <div className="col-lg-6 col-sm-6">
                          <div className="input-field">
                            <label>Age</label>
                            <input
                              type="number"
                              name="age"
                              className="form-control"
                              value={formValues.age}
                              onChange={handleInputChange}
                              placeholder="Enter age"
                              min="1"
                            />
                          </div>
                        </div>

                        {/* Pincode */}
                        <div className="col-lg-6 col-sm-6">
                          <div className="input-field">
                            <label>Pincode</label>
                            <input
                              type="text"
                              name="pincode"
                              className="form-control"
                              value={formValues.pincode}
                              onChange={handleInputChange}
                              placeholder="Enter pincode"
                              maxLength="6"
                              pattern="[0-9]{6}"

                            />
                          </div>
                        </div>

                        {/* Earning Type */}


                      </div>
                      <div className="col-lg-12 col-sm-6">
                        <div className="input-field">
                          <label>Upload<span className="red">*</span></label>
                          <input type="file" name="image" className="form-control" onChange={handleFileChange} />
                          <div className="file-preview text-center">
                            <img id="uploadFile" src={previewImage} alt="your image" />
                          </div>
                        </div>
                      </div>

                    </div>
                    <button className="submit-green-btn">Submit</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SallerUpdate;
